import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
Vue.config.productionTip = false

// const VConsole = require('vconsole')
// new VConsole()

new Vue({
  render: h => h(App),
}).$mount('#app')
